import { gql, useQuery, useLazyQuery } from "@apollo/client";
export const GET_MY_PMX_ACTIVITIES_QUERY = gql`
  query getMyPmxActivities($ids: [ID]) {
    getMyPmxActivities(input: { ids: $ids }) {
      __typename
      id
      trialNumber
      trialShortDescription
      bayNumber
      projectId
      source
      mainRepository {
        name
        id
        isStandard
        created
      }
    }
  }
`;

export function useGetMyPmxActivitiesQuery(skip: boolean) {
  const {
    data: activities,
    loading: activitesLoading,
    error,
    refetch: refetchActivites
  } = useQuery(GET_MY_PMX_ACTIVITIES_QUERY, {
    skip: skip,
    notifyOnNetworkStatusChange: true
  });

  return {
    activities,
    refetchActivites,
    activitesLoading,
    error
  };
}

export function useGetMyPmxActivitiesLazyQuery() {
  const [
    getMyPmxActivities,
    { data: activities, loading: activitesLoading, error: errorActivities }
  ] = useLazyQuery(GET_MY_PMX_ACTIVITIES_QUERY);

  return {
    activities,
    getMyPmxActivities,
    activitesLoading,
    errorActivities
  };
}
